import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent } from "vue"

import initConfig from "../CsdPublic/initConfig";
import { allBaseUrl } from "@/config/apiDomain";
import { AppConfig } from "@/utils/constant";
import { onMounted } from "vue";

import publicStore from "@/store/publicStore";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const config = {
  soft_id: AppConfig.soft_id,
  os: AppConfig.os,
  curr_ver: AppConfig.curr_ver,
  wxLoginAndPayDomain: allBaseUrl.qnwApi.url,
  qnwProjectDomain: allBaseUrl.qnwApi.url,
};

initConfig(config);

onMounted(() => {
  const store = publicStore();

  store.changeVipInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view, null, {
    default: _withCtx(({ Component }) => [
      _createVNode(_Transition, { name: "fade" }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }))
}
}

})